import React, { useState, useEffect } from "react"
import { observer } from "mobx-react"
import { BottomsheetDropdown } from "components"

const AssuredIncomeStar = ({ form, data }) => {
 

  return (
    <div className=''>
      <div className="my-3 my-md-4 mx-0">
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey='label'
          bottomsheetTitle={form.$("PT").label}
          menuList={form.$("PT").extra.optionList}
          value={form.$("PT").value}
          onSelect={form.$("PT").onChange}
          disabled={form.$("PT").disabled}
        />
      </div>
      <div className="my-3 my-md-4  mx-0" >

        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey='label'
          bottomsheetTitle={form.$("PPT").label}
          menuList={form.$("PPT").extra.optionList}
          value={form.$("PPT").value}
          disabled={form.$("PPT").disabled}
          onSelect={form.$("PPT").onChange}
        />
      </div>
    </div>
  )
}

export default observer(AssuredIncomeStar)
